import { Box } from '@mui/material';
import { getSignDocuments } from 'lib/api/integrations/digitalSignature';
import { SignDocumentsResponse } from 'lib/api/integrations/digitalSignature/types';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { errorHandler } from 'lib/functions/errors';
import { Pagination } from 'lib/types/shared';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

const BASE_PAGINATION = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

type SignDocument = SignDocumentsResponse['data'];

const SignDocuments = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<Pagination>(BASE_PAGINATION);
  const [documents, setDocuments] = useState<SignDocument>([]);

  const fetchDocuments = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    try {
      setLoading(true);
      const query = `page=${page}&pageSize=${pageSize}`;
      if (!user?.businessIdentifier) return;
      const response = await getSignDocuments(
        dispatch,
        user.businessIdentifier,
        query,
      );
      setDocuments(response?.data ?? []);
      setPagination(response?.pagination || BASE_PAGINATION);
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };

  const headers = [
    { label: 'Descripción', key: 'description', type: 'text' },
    { label: 'Estado', key: 'status', type: 'status-chip' },
    { label: 'Tipo de firma', key: 'signature', type: 'text' },
    { label: 'Fecha de Creación', key: 'createdAt', type: 'date' },
    { label: 'Firmado', key: 'isSigned', type: 'boolean-yes' },
    { label: 'URL', key: 'url', type: 'url' },
  ];

  useEffect(() => {
    void fetchDocuments({ page: 1, pageSize: 10 });
  }, []);

  return (
    <>
      <Box mt={2}>
        <HeaderWithActions
          title="Aca podras ver una lista con tus documentos firmados y pendientes de firma."
          variant="body1"
          buttons={[]}
          type="subHeader"
        />
        <TableWithPagination
          data={documents}
          setData={setDocuments}
          dataHeaders={headers}
          showActions
          pagination={pagination}
          setPagination={setPagination}
          searchData={fetchDocuments}
          setLoading={setLoading}
          exportToFile="xlsx"
          exportComplete
          lastElement
          loading={loading}
        />
      </Box>
    </>
  );
};

export default SignDocuments;
